import React, { Component } from "react";
import Select from 'react-select';
// Temporalmente desactivado para migrar a Vite
// import 'react-dates/initialize';
// import { DateRangePicker } from 'react-dates';
// import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";

moment.locale('es');
class ReportsDocumentTemplates extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            documentTemplates: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalDocumentTemplates: 0,
            showExport: true,
            showRut: false,
            selectedId: null,
            selectedTitle: null,
            selectedFrequency: null,
            selectedRequired: null,
            idOptions: [],
            titleOptions: [],
            requiredOptions: [
                {value: "Si", label: "Si"},
                {value: "No", label: "No"}
            ],
            periodOptions : [
                {value: "Recurrente", label: "Recurrente"},
                {value: "Única", label: "Única"}
            ],
            selectedDocumentIds: [], //For show extra fields toggle
            showAdvancedFilters: false,
            params : {
                documentTemplate:{
                    id: null,
                    title: null,
                    period: null,
                    required: null
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
    }

    getDocumentTemplates(){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/documents_template', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage
                }
            }).then(res=>{
                let documentTemplates = res.data.data;

                documentTemplates = documentTemplates.map(document => {
                    if (document.fields) {
                        document.fields = document.fields.split(',').map(item => item.trim()).join(', ');
                    }
                    return document;
                });

                this.setState({
                    documentTemplates,
                    showFrom: res.data.from,
                    showTo: res.data.to,
                    totalDocumentTemplates: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/documents_template', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const documentTemplateFilters = res.data;
            this.setState({
                idOptions: documentTemplateFilters.idOptions,
                titleOptions: documentTemplateFilters.titleOptions
            });
        });
    }

    exportReports() {
        const ids = this.state.idOptions.map(item => {
            const id = item.value.split('-')[1];
            return id;
        });
        const dataJSON = JSON.stringify(ids);

        axios.post('/api/export/documents_template', {
            data: dataJSON,
        }, {
            responseType: 'blob',
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = 'ReportePlantillaDocumentos.xls';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }


    componentDidMount() {
        this.getDocumentTemplates();
    };

    handleIdChange = (event) => {
        let value = (event) ? event.value.split('E-')[1] : null;

        const updatedParams = {
            ...this.state.params,
            documentTemplate: {
                ...this.state.params.documentTemplate,
                id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedId: event,
        }, this.getDocumentTemplates);
    }

    handleTitleChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            documentTemplate: {
                ...this.state.params.documentTemplate,
                title: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTitle: event,
        }, this.getDocumentTemplates);
    }

    handleFrequencyChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            documentTemplate: {
                ...this.state.params.documentTemplate,
                period: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedFrequency: event,
        }, this.getDocumentTemplates);
    }

    handleRequiredChange = (event) => {
        let value = event ? event.value : null;
        let requiredValue = null;

        if (value === "Si") {
            requiredValue = 1;
        } else if (value === "No") {
            requiredValue = 0;
        }

        const updatedParams = {
            ...this.state.params,
            documentTemplate: {
                ...this.state.params.documentTemplate,
                required: requiredValue
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRequired: event
        }, this.getDocumentTemplates);
    }

    setSelectedDocumentIds = (id) => {
        if (!this.state.selectedDocumentIds.includes(id)) {
            this.setState(prevState => ({
                selectedDocumentIds: [...prevState.selectedDocumentIds, id],
            }));
        }
    };

    unsetSelectedDocumentId = (id) => {
        this.setState(prevState => ({
            selectedDocumentIds: prevState.selectedDocumentIds.filter(item => item !== id),
        }));
    };

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, this.getDocumentTemplates);
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, this.getDocumentTemplates);
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearFilters = () => {
        this.setState({
            selectedId: null,
            selectedTitle: null,
            selectedFrequency: null,
            selectedRequired: null,
            selectedFields: null,
            params : {
                documentTemplate:{
                    id: null,
                    title: null,
                    period: null,
                    required: null
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getDocumentTemplates);
    };

    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getDocumentTemplates);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context; 
    return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.plantilla_de_documentos')}
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalDocumentTemplates}</span> {lang.get('messages.plantillas_de_documentos_en_la_plataforma')}
                        </p>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {this.state.showExport &&
                            <a
                                id="export"
                                className="btn btn-primary px-10 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.exportReports();
                                }}
                                >{lang.get('messages.exportar')}</a>
                        }
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}:</div>
                        <a
                            className="datatable-clear-filters float-righ text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>

                    <div className="d-flex justify-content-between mb-4 default">
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Id</label>
                            <Select
                                value={this.state.selectedId}
                                onChange={this.handleIdChange}
                                options={this.state.idOptions}
                                placeholder={<div>{lang.get('messages.buscar_por')} Id</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.frecuencia')}</label>
                            <Select
                                value={this.state.selectedFrequency}
                                onChange={this.handleFrequencyChange}
                                options={this.state.periodOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_frecuencia')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.nombre_de_plantilla')}</label>
                            <Select
                                value={this.state.selectedTitle}
                                onChange={this.handleTitleChange}
                                options={this.state.titleOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_nombre_de_plantilla')}</div>}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.requerido')}</label>
                                    <Select
                                        value={this.state.selectedRequired}
                                        onChange={this.handleRequiredChange}
                                        options={this.state.requiredOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_requerido')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>

                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '80px' }} onClick={() => this.handleSort('id')}>
                                    Id
                                    {this.state.params.sort.column === 'id' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('period')}>
                                    {lang.get('messages.frecuencia')}
                                    {this.state.params.sort.column === 'period' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '350px' }} onClick={() => this.handleSort('title')}>
                                    {lang.get('messages.nombre')}
                                    {this.state.params.sort.column === 'title' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('required')}>
                                    {lang.get('messages.requerido')}
                                    {this.state.params.sort.column === 'required' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '550px' }} onClick={() => this.handleSort('fields')}>
                                    {lang.get('messages.campos_extras')}
                                    {this.state.params.sort.column === 'fields' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.documentTemplates.map((document_template) => (
                                <tr key={document_template.id} id={document_template.id}>
                                    <td className="text-dark-75 font-weight-bolder">{`D-${document_template.id}`}</td>
                                    <td className="text-dark-50 font-weight-bold">{document_template.period}</td>
                                    <td className="text-dark-75 font-weight-bolder">{document_template.title}</td>
                                    <td className="text-dark-50 font-weight-bold">{document_template.required ? "Si" : "No"}</td>
                                    <td className="text-dark-75 font-weight-bolder">
                                        {document_template.fields && (
                                            <>
                                                {this.state.selectedDocumentIds.includes(document_template.id) ? (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {e.preventDefault(); this.unsetSelectedDocumentId(document_template.id);}}
                                                        className="hide-extra-fields text-primary font-weight-bold"
                                                    >
                                                        <u>{lang.get('messages.ocultar_campos_extras')}</u>
                                                    </a>
                                                ) : (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {e.preventDefault(); this.setSelectedDocumentIds(document_template.id);}}
                                                        className="show-extra-fields text-primary font-weight-bold"
                                                    >
                                                        <u>{lang.get('messages.ver_campos_extras')}</u>
                                                    </a>
                                                )}

                                                {this.state.selectedDocumentIds.includes(document_template.id) && (
                                                    <div className="extra-fields mt-3 text-dark-50 font-weight-bold">
                                                        {document_template.fields}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalDocumentTemplates} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsDocumentTemplates;
